import httpClient from "../http/http-client";
import { ICrpFigures, ICrpGenerateResponse, ICrpReport, ICrpReportCreate } from './crp-report.model';

export default class CrpReportService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<ICrpReport[]> {
    return this.http.get('crp-report')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getOne(id: string): Promise<ICrpReport> {
    return this.http.get(`crp-report/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async create(details: ICrpReportCreate): Promise<ICrpReport> {
    return this.http.post('crp-report', sanitiseCrpPayload(details))
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async update(id: string, details: Partial<ICrpReport>): Promise<ICrpReport> {
    return this.http.patch(`crp-report/${id}`, sanitiseCrpPayload(details))
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async remove(id: string): Promise<void> {
    return this.http.delete(`crp-report/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getFigures(id: string): Promise<ICrpFigures> {
    return this.http.get(`crp-report/${id}/figures`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async generate(id: string): Promise<ICrpGenerateResponse> {
    return this.http.post(`crp-report/${id}/generate`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async share(id: string): Promise<{ success: boolean, shareId: string }> {
    return this.http.post(`crp-report/${id}/share`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async unshare(id: string): Promise<void> {
    return this.http.delete(`crp-report/${id}/share`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}

/**
 * Formik initialises id and date fields to '', and '' in a Postgres UUID or date column is an error,
 * not an empty value. Normalise to null on the way out.
 */
const ID_AND_DATE_FIELDS = [
  'baselineReportPeriodId',
  'currentReportPeriodId',
  'publicationDate',
  'signOffDate',
]

function sanitiseCrpPayload<T extends Record<string, any>>(payload: T): T {
  const cleaned: Record<string, any> = { ...payload }
  for (const field of ID_AND_DATE_FIELDS) {
    if (cleaned[field] === '') cleaned[field] = null
  }
  return cleaned as T
}
